import React from "react";
import { Link } from "react-router-dom";
import LegalPage from "./LegalPage";

// DRAFT — grounded in how the platform actually works as of Aug 2026 (incl.
// the no-refunds rule shown at checkout), but not yet reviewed by counsel.

export default function TermsOfService() {
  return (
    <LegalPage title="Terms of Service" updated="August 19, 2026">
      <p>
        These terms are an agreement between you and Feis.link, 21432 Lynn Rd.,
        Wheatley, Ontario N0P 2P0, Canada ("Feis.link", "we", "us"). By creating an
        account or registering for an event on Feis.link, you agree to them.
      </p>

      <h2>What Feis.link is</h2>
      <p>
        Feis.link is a registration and event-management platform for Irish dance events.
        Each event on the platform — every feis, grade examination and oireachtas — is run
        by its own <b>organizer</b>. The organizer sets the syllabus, fees, deadlines and
        rules for their event and is responsible for running it. When you register for an
        event, your entry (and your payment for it) is a transaction with that organizer;
        Feis.link provides the software and charges a service fee.
      </p>

      <h2>Accounts</h2>
      <ul>
        <li>You must be an adult to hold an account. Teachers and organizers act on behalf of their school or event and confirm they have the authority to do so.</li>
        <li>Keep your login credentials secure — actions taken from your account are your responsibility.</li>
        <li>Information you provide must be accurate, including dancer details used for eligibility (name, date of birth, gender, level and school).</li>
      </ul>

      <h2>Registrations and entries</h2>
      <ul>
        <li>Entry eligibility (age group, gender category, level, team composition) is determined by the event's syllabus and rules. The platform enforces what it can mechanically, but you are responsible for the accuracy of the information eligibility is computed from.</li>
        <li>Organizers may correct, reject or remove entries that violate their event's rules.</li>
        <li>Entry changes are subject to the event's deadlines and any change fees the organizer sets.</li>
        <li>Where a teacher overrides a flagged team-composition rule, that override is recorded and may be reviewed under the governing body's rules.</li>
      </ul>

      <h2>Fees and payments</h2>
      <ul>
        <li>The fees for an event — entry fees, family fees, school assessments, late surcharges and any other charges — are set by the organizer and shown before you pay.</li>
        <li>Payments are processed by Stripe. Funds for an event go to that event's organizer; Feis.link's service fee is charged as part of the transaction and is shown at checkout.</li>
        <li><b>All sales are final. Entry fees and related charges are non-refundable</b>, including if a dancer withdraws or does not attend, except where the event's organizer directs a refund or applicable law requires one.</li>
        <li>If an event is cancelled or materially changed, remedies (including any refunds) are the organizer's responsibility.</li>
      </ul>

      <h2>Results and event operations</h2>
      <p>
        Publishing results is part of competition: dancer names, schools, placements and
        judges' names appear on public results pages and printed materials once an
        organizer publishes them. Scores, recalls and awards are determined by the event's
        adjudicators and tabulation under the organizer's rules; Feis.link records and
        computes what the organizer's team enters.
      </p>

      <h2>Acceptable use</h2>
      <ul>
        <li>No unauthorized access, scraping, or interference with the platform.</li>
        <li>No entering dancers you have no authority to enter, and no false eligibility information.</li>
        <li>No use of the platform to harass or harm others.</li>
      </ul>

      <h2>The platform is provided "as is"</h2>
      <p>
        We work to keep Feis.link accurate and available, but the platform is provided
        without warranties of any kind. To the maximum extent permitted by law, Feis.link's
        total liability for any claim arising out of the platform is limited to the service
        fees you paid to Feis.link in the twelve months before the claim. We are not liable
        for the acts, omissions or events of organizers, including event cancellation.
        Nothing in these terms limits liability that cannot be limited under applicable law.
      </p>

      <h2>Termination</h2>
      <p>
        You can stop using Feis.link at any time. We may suspend or close accounts that
        violate these terms. Provisions that by their nature survive (payment records,
        liability limits, published results) survive account closure.
      </p>

      <h2>Governing law and changes</h2>
      <p>
        These terms are governed by the laws of Ontario and the federal laws of
        Canada applicable there. We may update these terms; material changes will be posted
        on this page with a new "Last updated" date, and continued use after a change is
        acceptance of it.
      </p>

      <h2>Contact</h2>
      <p>
        <a href="mailto:info@feis.link">info@feis.link</a>
      </p>

      <div className="legal-crosslink">
        See also our <Link to="/privacy">Privacy Policy</Link>.
      </div>
    </LegalPage>
  );
}
